/**
 * AlertsPage - Alerts centre page wrapper
 * Planner - Alert System
 */

import AlertCentre from '@/components/alerts/AlertCentre'

export default function AlertsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Alerts</h1>
        <p className="text-muted-foreground">
          Monitor system alerts and notifications
        </p>
      </div>

      <AlertCentre />
    </div>
  )
}
